<!--
component: MapPane
author: Ken Nakamura
description: 地図検索画面
-->
<template>
  <section class="map-pane">
    <div>
      <div class="split left-box" @touchstart.stop @touchmove.stop @touchend.stop>
        <MapComponent
         :tileUrl="plotUrl"
         :tileUrlAlt="plotUrlAlt"
         :plotDef="plotDef"
         :plotDefAlt="plotDefAlt"
         :sheetUrl="sheetUrl"
         :bgmapList="bgmapList"
         :centerx="centerx" :centery="centery"
         :targetPlot="targetPlotData"
         :zoom="zoom"
          @select="onMapSelectionChanged" />
      </div>
      <div class="split right-box" v-show="$vuetify.breakpoint.name != 'xs'">
        <v-container fluid class="container-fluid">
          <!--
          <v-row class="layer-switcher" dense v-sho="mode=7" py-1>
            <v-col style="background-color:none;">道路種別図</v-col>
            <v-col>
            <v-btn-toggle v-model="douroShubetsuVisible" mandatory background-color="white">
              <v-btn active-class="light-blue darken-3 white--text">非表示</v-btn>
              <v-btn active-class="light-blue darken-3 white--text">表示</v-btn>
            </v-btn-toggle>
            </v-col>
          </v-row>
          -->
          <v-row id="sheet-panel" my-1 mx-0 px-0>
            <v-col :cols="nendoCols" :xl="nendoXlCols"
                v-show="sheetVisible"
                v-for="(nendo, index) in nendoList" :key="index"
                style="margin:0px 0px !important; padding: 1px 2px !important;">
              <v-btn @click="selectNendo(nendo)" width="100%"
                class="blue lighten-4 green--text text--darken-4"
                :class="textClass"
                style="margin:1px 1px !important;">
                {{nendo.name}}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>

        <div style="margin: 1em; ">
          <table id="selected-plot">
            <thead>
              <tr>
                <!--
                <th>{{plotDef.title}}</th>
                -->
                <th>{{selectedPlotTitle}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(k, index) in features"
                @click="selectRow(k)"
                :key="index"
                :class="{selected:isSelectedRow(k)}"
              >
                <!--<td>{{ k.get(plotDef.label) }}</td>-->
                <td>{{ plotLabel(k) }}</td>
          </tr>
            </tbody>
          </table>
          <div v-show="features.length>1">
            <v-alert dark color="#335566">
              2件以上あります。閲覧したい番号をクリックしてください。
            </v-alert>
          </div>
        </div>

        <div style="margin: 1em 0; text-align: center; display: flex; flex-direction: column; align-items: center;">
          <v-btn @click="browse" :disabled="!browsable"
            color="primary" class="text-h5 py-7 mb-8">
            {{ browseButtonTitle }}
          </v-btn>
        </div>
        <div class="guide-container" v-if="mode === 5">
          <MapObjectGuideKaihatsuTakuzo />
        </div>
        <div class="guide-container" v-if="mode === 7">
          <MapObjectGuideKyoai />
        </div>

        <div id="scale-buttons" class="container" v-show="scalevisible">
          <div class="btn btn-primary">1/1000</div>
          <div class="btn btn-secondary">1/1500</div>
          <div class="btn btn-secondary">1/2000</div>
          <div class="btn btn-secondary">1/2500</div>
          <div class="btn btn-secondary">1/5000</div>
        </div>
      </div>
    </div>
    <!-- スマホ用データ選択画面 幅が599pxまでならこちらが出てくる(breakpoint=xs) -->
      <v-bottom-sheet
        v-model="bottomSheet"
        hide-overlay persistent no-click-animation open-delay="1" scrollable
        style="bottom:0;">
        <v-card
          color="rgb(118, 164, 170)"
          width="100%"
          rounded
          v-touch="{
            up: () => touchUp(),
            down: () => touchDown(),
          }"
        >
          <v-card-title style="height:2em;">
            <v-row>
              <v-col class="pa-0" align="center">
                <v-icon>mdi-minus-thick</v-icon>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text class="pa-2 mb-8" style="overflow-y:scroll;">
            <v-container fluid class="container-fluid">
              <v-row id="sheet-panel" my-1 mx-0 px-0>
                <v-col :cols="nendoCols" :xl="nendoXlCols"
                    v-show="sheetVisible"
                    v-for="(nendo, index) in nendoList" :key="index"
                    style="margin:0px 0px !important; padding: 1px 2px !important;">
                  <v-btn @click="selectNendo(nendo)" width="100%"
                    class="blue lighten-4 green--text text--darken-4"
                    :class="textClass"
                    style="margin:1px 1px !important;">
                    {{nendo.name}}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
            <div style="margin: 1em; ">
              <table id="selected-plot">
                <thead>
                  <tr>
                    <th>{{plotDef.title}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(k, index) in features"
                    @click="selectRow(k)"
                    :key="index"
                    :class="{selected:isSelectedRow(k)}"
                  >
                    <td>{{ plotLabel(k) }}</td>
                  </tr>
                </tbody>
              </table>
              <div v-show="features.length>1">
                <v-alert dark color="#335566">
                  2件以上あります。閲覧したい番号をクリックしてください。
                </v-alert>
              </div>
            </div>

            <div style="text-align: center;">
              <v-btn @click="browse" :disabled="!browsable"
                color="primary" class="text-h5 py-7 mb-10">
                {{ browseButtonTitle }}
              </v-btn>
            </div>

            <div class="guide-container" v-if="mode === 5">
              <MapObjectGuideKaihatsuTakuzo />
            </div>
            <div class="guide-container" v-if="mode === 7">
              <MapObjectGuideKyoai />
            </div>

            <div id="scale-buttons" class="container" v-show="scalevisible">
              <div class="btn btn-primary">1/1000</div>
              <div class="btn btn-secondary">1/1500</div>
              <div class="btn btn-secondary">1/2000</div>
              <div class="btn btn-secondary">1/2500</div>
              <div class="btn btn-secondary">1/5000</div>
            </div>
          </v-card-text>
        </v-card>
      </v-bottom-sheet>
		<Dialog error :open="authDialog" :ok="()=>authDialog=false" :to="'/'"
      title="ユーザー認証" body="ユーザー認証に失敗しました。ログインし直して下さい。"/>
  </section>
</template>

<script>
import MapComponent from '../components/Map.vue'
import { apiUrl, dbglog, gaiyoURL, /*elvUrl,*/ plotUrl, plotUrlAlt } from '../common/utils'
import constants from '../common/constants'
import { callGetApi } from '../common/apiAccess'
import Dialog from '../components/Dialog.vue'
import MapObjectGuideKaihatsuTakuzo from '../components/MapObjectGuideKaihatsuTakuzo.vue'
import MapObjectGuideKyoai from '../components/MapObjectGuideKyoai.vue'

export default {
  data () {
    return {
      scalevisible: false,
      existsGaiyo: false,
      plotUrl: '',
      plotUrlAlt: '',
      plotDef: null,
      plotDefAlt: null,
      sheetUrl: '',
      nendoList: [],
      bgmapList: [],
      queryingSheet: false,
      nendoCols: 12,
      nendoXlCols: 6,
      textClass: 'text-h6',
      targetPlotData: this.targetPlot,
      selectedLayer: '',
      // swipe用変数
      position: 0,
      startX: 0,
      moveX: 0,
      width: 0,
      authDialog: false,
    }
  },
  components: {
    MapComponent,
    Dialog,
    MapObjectGuideKaihatsuTakuzo,
    MapObjectGuideKyoai,
  },
  props: {
    zoom: {
      type: Number,
      default: 18,
    },
    targetPlot: {
      type: Object,
      default: null,
    },
  },
  created () {
    this.plotUrl = plotUrl();
    this.plotUrlAlt = plotUrlAlt();
    this.plotDef = constants.tileDef[this.mode];
    if (this.mode == 5) {
      this.plotDefAlt = constants.tileDef[6];
    }
    dbglog('MapPane:' + this.plotDef);
    if (this.sheetVisible) {
      if (this.mode == 1) {
        this.sheetUrl = this.$store.state.mapOrigin + constants.tileDef[8].url;
      }
      else if (this.mode == 5) {
        this.sheetUrl = this.$store.state.mapOrigin + constants.tileDef[9].url;
      }
    }
    if (this.mode == 7) {
      ///*
      this.bgmapList = [
        this.$store.state.mapOrigin + constants.tileDef[10].url,
        this.$store.state.mapOrigin + constants.tileDef[11].url,
      ];
      //*/
      /*
      this.bgmapList = [];
      if (this.$store.state.seibiSokushinVisible) {
        this.bgmapList.push(this.$store.state.mapOrigin + constants.tileDef[10].url);
      }
      if (this.$store.state.douroShubetsuVisible) {
        this.bgmapList.push(this.$store.state.mapOrigin + constants.tileDef[11].url);
      }
      */
    }
  },
  mounted () {
    if (this.unauthorized) {
      this.message = 'ユーザー認証されていません。';
      this.$router.replace('/');
    }
    this.$store.commit('setCurrentPage', 5);
    this.setMessage();
    //選択されているプロットの番号が保存されている場合
    if (this.selectedNo) {
      this.searchGaiyo(this.selectedNo, (data) => {
        this.existsGaiyo = (data && data.length);
      });
    }
    //this.targetPlotData = this.targetPlot; //ここでは遅い
    //test
    //console.log(this.targetPlot);
  },
  computed: {
    token () {
      return this.$store.state.token;
    },
    unauthorized () {
      return this.token == undefined || this.token == null || this.token.length == 0;
    },
    authorized () {
      return !this.unauthorized;
    },
    message: {
      get() { return this.$store.state.message; },
      set(val) { this.$store.commit('setMessage', val); }
    },
    browsable () {
      return this.isSelected && this.existsGaiyo;
    },
    features: {
      get() { return this.$store.state.features; },
      set(val) { this.$store.commit('setFeatures',val); }
    },
    sheets: {
      get() { return this.$store.state.sheets; }
    },
    mode () {
      return this.$store.state.mode;
    },
    authority () {
      //return this.$store.state.authority;
      return this.$store.state.userInfo.authority;
    },
    sheetVisible () {
      //return (this.authority >= 1) && (this.mode == 1 || this.mode == 5);
      // authority=4 は住所検索と番号検索のみ（仮）
      return (this.authority >= 1 && this.authority != 4) && (this.mode == 1 || this.mode == 5);
    },
    douroShubetsuVisible: {
      get() {
        return this.$store.state.douroShubetsuVisible;
      },
      set(val) {
        this.$router.commit('setDouroShubetsuVisible', val);
      }
    },
    gaiyoId () {
      return this.$store.state.gaiyoId;
    },
    gaiyo () {
      return this.$store.state.gaiyoData;
    },
    selectedNo: {
      get() { return this.$store.state.selectedNo; },
      set(val) { this.$store.commit('setSelectedNo', val); }
    },
    selectedId: {
      get() { return this.$store.state.selectedId; },
      set(val) { this.$store.commit('setSelectedId', val); }
    },
    gaiyoList() {
      return this.$store.state.gaiyoList;
    },
    centerx() {
      return this.$store.state.centerx;
    },
    centery() {
      return this.$store.state.centery;
    },
    selectedPlotTitle() {
      let title = this.plotDef.title;
      if (this.plotDefAlt)
        title += '・' + this.plotDefAlt.title;
      if (this.mode == 5)
        title = '許可番号（開発・宅造・盛土規制法）';
      return title;
    },
    browseButtonTitle() {
      if (this.mode == 1) {
        return '概要書を閲覧';
      }
      else if (this.mode == 2) {
        return '昇降機台帳を閲覧';
      }
      else if (this.mode == 3) {
        return '定期報告概要書を閲覧';
      }
      else if (this.mode == 5) {
        if (this.selectedLayer == 'vectorLayer')
          return '開発登録簿を閲覧';
        else if (this.selectedLayer == 'vectorLayerAlt')
          if (this.selectedNo.includes('土'))
            return '土石の堆積計画平面図を閲覧';
          else
            return '造成計画平面図を閲覧';
        else
          return '閲覧';
      }
      else {
        return '閲覧';
      }
    },
    isSelected() {
      return this.selectedNo !== undefined && this.selectedNo !== null
          && this.selectedNo != '';
    },
    wardCode() {
      return this.$store.state.wardCode;
    },
    wardName() {
      return this.$store.state.wardName;
    },
    townCode() {
      return this.$store.state.townCode;
    },
    townName() {
      return this.$store.state.townName;
    },
    oyaban() {
      return this.$store.state.oyaban;
    },
    edaban() {
      return this.$store.state.edaban;
    },
    bottomSheet() {
      return ((this.$store.state.features.length > 0) && (this.$vuetify.breakpoint.name == 'xs'));
    }
  },
  watch: {
    features (newValue, oldValue) {
      dbglog(`MapPane: watch.features(${newValue},${oldValue})`, 2);
      if (newValue != null) {
        if (newValue.length == 0 || newValue.length > 1) {
          this.selectedId = '';
          this.selectedNo = '';
          this.selectedLayer = '';
        }
        else if (newValue.length == 1) {
          this.selectRow(newValue[0]);
        }
      }
    },
    sheets (newValue, oldValue) {
      if ((newValue != oldValue) && !this.queryingSheet) {
        const ku = this.wardCode - 14100;
        let sheets = '';
        for (let i = 0; i < newValue.length; i++) {
          sheets += (sheets.length > 0 ? ',' : '') + newValue[i].indexId;
        }
        let url = '';
        if (this.mode == 1) {
          url = apiUrl('KenkakuPlotIndexNendo') + `?ku=${ku}&sheets=${sheets}`;
        }
        else if (this.mode == 5) {
          url = apiUrl('KaihatsuPlotIndexNendo') + `?ku=${ku}&sheets=${sheets}`;
        }
        else {
          return;
        }
        this.queryingSheet = true;
        callGetApi(url, (data) => {
          this.nendoList = [];
          if (data.length) {
            if (data.length > 10) {
              this.nendoCols = 6;
              this.nendoXlCols = 4;
              this.textClass = 'text-h7';
            }
            else {
              this.nendoCols = 12;
              this.nendoXlCols = 6;
              this.textClass = 'text-h6';
            }
            for (let i = 0; i < data.length; i++) {
              for (let j = 0; j < newValue.length; j++) {
                if (data[i].id == newValue[j].indexId) {
                  this.nendoList.push({
                    id: data[i].id,
                    name: data[i].name,
                    pageNo: newValue[j].pageNo,
                    branch: newValue[j].branch
                  });
                  break;
                }
              }
            }
          }
          this.queryingSheet = false;
        });
      }
    },
  },
  methods: {
    plotKey(layerFeature) {
      const k = layerFeature.feature ?? layerFeature;
      let result = k.get(this.plotDef.key);
      if (this.plotDefAlt !== null) {
        //if (result === undefined || result === null || result.length === undefined || result.length == 0) {
        if (!result) {
          result = k.get(this.plotDefAlt.key);
        }
      }
      return result;
    },
    isSelectedRow(k) {
      //const layer = k.layer;
      const feature = k.feature;
      const no = this.plotKey(feature);
      //const selNo = this.selectedNo;
      const selNo = this.selectedId;
      const hit = (no == selNo)
      //console.log(`k:${no} sel:${selNo} hit:${hit}`)
      return hit;
    },
    plotLabel(k) {
      const layer = k.layer;
      const feature = k.feature;
      let result = '不明';
      if (layer == 'vectorLayer') {
        result = feature.get(this.plotDef.label);
        if (!result)
          result = feature.get(this.plotDef.key);
      }
      else if (layer == 'vectorLayerAlt') {
        result = feature.get(this.plotDefAlt.label);
        if (!result) {
          result = feature.get(this.plotDefAlt.key);
        }
      }
      return result ?? '';
    },
    setMessage () {
      if (this.targetPlot) {
        this.$store.commit('setMessage', '　');
      }
      else {
        let addrText = `${this.wardName} ${this.townName}`;
        if (this.oyaban > 0) {
          addrText += ` ${this.oyaban}`;
          if (this.edaban > 0) {
            addrText += `-${this.edaban}`;
          }
        }
        this.$store.commit('setMessage', `地図検索：${addrText}`);
      }
    },
    // 呼び出される事がない？
    onMapSelectionChanged (selection) {
      //this.features = selection;
      //this.existsGaiyo = false;
      dbglog(`onMapSelectionChanged(${selection})`, -1);
      if (selection.length == 1) {
        dbglog(`MapPane: onMapSelectionChanged(${selection[0]})`, -1);
        this.selectRow(selection[0]);
      }
    },
    /**
     * プロット一覧から特定の行を選択状態にする
     * @param { PlotData } target 選択状態にするプロットデータ
     */
    selectRow (target) {
      //test
      //this.targetPlotData = target.feature;
      //
      this.selectedLayer = target.layer;
      const selNo = this.plotKey(target);
      let selLabel = this.plotLabel(target);
      // 開発・造成・土石の堆積、指定道路用にSEQをselectedIdに保存
      //this.selectedNo = selNo;
      this.selectedId = selNo;
      this.selectedNo = selLabel;
      //開発・造成・土石の堆積の別を判定
      /*
      if (selNo != selLabel) {
        this.$store.commit('setSearchTargetType', selLabel.includes('規') ? 1 : 0);
      }
      */
      this.$store.commit('setSearchTargetType', target.layer == 'vectorLayerAlt' ? 1 : 0);
      // 選択された番号の概要書データが存在するか調べて
      // 閲覧ボタンの使用可否を設定する（建築のみ）
      this.searchGaiyo(this.selectedNo, (data) => {
        this.existsGaiyo = (data && data.length);
      });
    },
    selectNendo (nendo) {
      dbglog(` selected: id=${nendo.id}, pageNo=${nendo.pageNo}, branch=${nendo.branch}`);
      this.$store.commit('setIndexId', nendo.id);
      this.$store.commit('setNendoName', nendo.name);
      //プロット地図画面の入力値をクリア
      this.$store.commit('setSearchYear', 0);
      this.$store.commit('setSearchBango', '');
      //
      this.$router.push({ name: 'plot-map', params: { sheet: nendo.pageNo } });
    },
    /**
     * 現在選択されているプロットの概要書を表示する
     */
    browse () {
      this.$store.commit('setUkeNo', this.selectedNo);
      this.$store.commit('setGaiyoId', this.selectedId);
      this.$router.push({ name: 'loading', params: { action: 1 }});
    },
    /**
     * 指定された受付番号のデータを検索する
     * （リスト選択時に閲覧ボタン使用可否を決定するために呼び出される）
     * @param {String} ukeNo 受付番号
     */
    searchGaiyo (ukeNo, callback) {
      if (ukeNo == null || ukeNo.length == 0) {
        this.existsGaiyo = false; //暫定措置
        return;
      }
      this.existsGaiyo = true; //暫定措置

      let url;
      if (this.mode == 1) {
        url = gaiyoURL() + '?uke_no=' + ukeNo;
      }
      else if (this.mode == 2) {
        //url = elvUrl() +  '?uke_no=' + ukeNo;
        return;
      }
      else {
        return;
      }
      dbglog(url);

      fetch(url, {
        mode: 'cors',
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + this.token,
        },
      })
      .then((response) => {
        dbglog(response);
        if (response.ok) {
          return response.json();
        }
        else {
          return response.status;
        }
      })
      .then((data) => {
        dbglog(data);
        if (data == 401) {
          this.loading = false;
          this.progressMessage = 'ユーザ認証に失敗しました。';
          this.authDialog = true;
          return;
        }
        callback(data);
      })
      .catch((err) => {
        dbglog(`MapPane.vue.searchGaiyo(${ukeNo}): ${err}`);
      });
    },
    onScroll(event) {
      //console.log(event.target.scrollTop);
      if(event.target.scrollTop == 200){
        //console.log('in');
        document.getElementsByClassName('v-dialog__content')[0].style.height = '90%';
        document.getElementsByClassName('v-dialog__content')[0].style.bottom = '0';
        document.getElementsByClassName('v-dialog__content')[0].style.top = 'revert';
      }else if(event.target.scrollTop == 0){
        document.getElementsByClassName('v-dialog__content')[0].style.height = '30%';
        document.getElementsByClassName('v-dialog__content')[0].style.bottom = '0';
        document.getElementsByClassName('v-dialog__content')[0].style.top = 'revert';
      }
    },
    touchUp(){
      if(document.querySelector('.v-bottom-sheet') != null){
        document.querySelector('.v-bottom-sheet').style.height = '90%';
      }
    },
    touchDown(){
      if(document.querySelector('.v-bottom-sheet') != null){
        document.querySelector('.v-bottom-sheet').style.height = '30%';
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/common/common.css";
@import "../styles/split-alt.css";
thead {
  background-color: rgb(56, 110, 155);
  color: mintcream;
}
.split {
  //height: 100%;
  height: calc(100% - 12px);
  padding: 6px 0;
}
.right-box {
  right: 0;
  width: 30%;
  //height: 100%;
  height: calc(100% - 24px);
  margin: 4px 0;
  overflow-y: auto;
  background-color: rgb(118, 164, 170);
  display: flex;
  flex-direction: column;
}
.acceptButton {
  font-size: 2rem;
  padding: 0.5em 1.5em;
}
/*
.selected {
  background-color: rgb(238, 255, 0);
}
*/
#selected-plot {
  background-color: lightsteelblue;
  font-size: 1.25rem;
  width: 100%;
  margin: 0.5em 0;
  text-align: center;
}

::v-deep .v-bottom-sheet {
  height: 30%;
}

.v-dialog__content {
  z-index:2 !important;
}

.guide-container {
  margin-top: auto;
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
}
</style>